/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps } from '@mui/material/styles';

export const facetNavigationFacetEntryFormControlLabelSX: SxProps = {
	width: ['auto', 'auto', '100%'],
	mb: '10px',
};

export const facetNavigationFacetEntrySwatchSX: SxProps = {
	mb: 0,
	mr: 0,
};
